import { TopContainer, TipsToReduce, ReceiveResult, ActionButtons } from './components';
import styled from 'styled-components/macro';
import { Co2FootprintVO } from 'vo';
import { CalculatorFormValues, Co2FootprintsVOs } from 'common/types';
import { DEVICE, TYPOGRAPHY } from '@net0-calc/common/assets/styles';
type Props = {
  formValues: CalculatorFormValues;
  co2FootprintSumVO: Co2FootprintVO;
  co2FootprintsVOs: Co2FootprintsVOs;
  answerId?: string;
};

export const Result = ({ formValues, answerId = '', co2FootprintSumVO, co2FootprintsVOs }: Props) => {
  return (
    <Root>
      <CreamSection>
        <TopContainer
          co2FootprintSumVO={co2FootprintSumVO}
          co2FootprintsVOs={co2FootprintsVOs}
          formValues={formValues}
        />
      </CreamSection>
      <SectionDivider />
      <ContentSection>
        <TipsToReduce />
      </ContentSection>
      <SectionDivider />
      <ContentSection>
        <ActionButtons answerId={answerId} />
      </ContentSection>
      <ContentSection>
        <ReceiveResult answerId={answerId} />
      </ContentSection>
      <FooterRow>
        <PoweredByLink href="https://net0.com/" target="_blank" rel="noopener noreferrer">
          Powered by Net0
        </PoweredByLink>
      </FooterRow>
    </Root>
  );
};

const Root = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const CreamSection = styled.section`
  background-color: var(--color8);
  margin: 0 -16px;
  padding: 32px 16px 40px;

  @media ${DEVICE.laptop} {
    margin: 0 -80px;
    padding: 40px 80px 56px;
  }
`;

const SectionDivider = styled.div`
  width: 60px;
  height: 3px;
  background: var(--color2);
  border-radius: 2px;
  margin: 32px 0;

  @media ${DEVICE.laptop} {
    margin: 48px 0;
    width: 80px;
  }
`;

const ContentSection = styled.section`
  width: 100%;
`;

const FooterRow = styled.div`
  display: flex;
  justify-content: center;
  padding: 32px 0 16px;
  border-top: 1px solid var(--color10);
  margin-top: 24px;

  @media ${DEVICE.laptop} {
    padding: 48px 0 24px;
    margin-top: 40px;
  }
`;

const PoweredByLink = styled.a`
  ${TYPOGRAPHY.captionRegular10}
  color: var(--color9);
  text-decoration: none;
  letter-spacing: 0.05em;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }
`;
